import React from 'react';
import { hydrate } from 'react-dom';
const BrowserRouter = require('react-router-dom').BrowserRouter;
import App from './ui/App';
import { config } from './clientConfig';

// Set webpack publicPath from window variable (injected in HTML).
// This fixes FontAwesome fonts by ensuring webpack resolves asset paths correctly.
// IMPORTANT: Only modify webpack paths for feature branch deployments (when subdirectory exists).
// In local development (no subdirectory), leave webpack paths alone so webpack-dev-server works correctly.
if (typeof window !== 'undefined' && (window as any).__TB_SUBDIRECTORY__) {
  const subdirectory = (window as any).__TB_SUBDIRECTORY__;

  // Only modify webpack publicPath if we have a non-empty subdirectory (feature branch).
  // In local development, subdirectory is empty string, so we skip this.
  if (subdirectory && typeof __webpack_public_path__ !== 'undefined') {
    __webpack_public_path__ = `${subdirectory}/`;
  }
}

hydrate(
  <BrowserRouter basename={config.subdirectory}>
    <App defaultRedirect={config.dashboard.defaultRedirect} />
  </BrowserRouter>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
